import i18n from "../../../../../../constants/i18n";
import { TalkhattabatConversationType } from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";

const ReactivateKhattabaClient = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
  userID: number;
  conversationID: string;
  alkhattabaUUID: string;
  clientUUID: string;
}>((props) => {
  const {
    theme,
    conversationType,
    conversationID,
    userID,
    alkhattabaUUID,
    clientUUID
  } = props;
  const { colors, unitX } = theme;

  const isOneOOneCConversation = conversationType === "101C";
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get()

  if (!isOneOOneCConversation || isKhattabaAiAdmin) {
    return;
  }

  const {
    hasBeenReactivated,
    stringifiedReactivatedAt,
    shouldShowReactivationProcess
  } = getKhattabatStore().getKhattabaClientToReactivateDetails({ userID });

  if (!shouldShowReactivationProcess) {
    return;
  }

  return hasBeenReactivated ? (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={20}
      text={stringifiedReactivatedAt}
      isSpan={false}
      color={colors.all.black}
      style={{
        width: "90%"
      }}
    />
  ) : (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: colors.all.green,
        borderRadius: 36 * unitX,
        cursor: "pointer"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {
        getKhattabatStore().requestReactivatingKhattabaClient({
          clientConversationID: conversationID,
          userID,
          alkhattabaUUID,
          clientUUID
        });
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("NOTICE_EMAIL")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default ReactivateKhattabaClient;
